import { combineReducers } from "redux";

import { reduceMapViewport } from "./viewport";
import { reduceMapPanels } from "./panels";
import { reduceMapTitle } from "./title";
import { reduceInformationWindow } from "./informationWindow";
import { reduceMapContribution } from "./contribution";
import { reduceMapElements } from "./elements";
import { reduceFilters } from "./filters";

import { reduceMapInitialization } from "./initialize";
import reduceCityWalk from "../cityWalks";

const mapReducer = combineReducers({
  viewport: reduceMapViewport,
  panels: reduceMapPanels,
  title: reduceMapTitle,
  informationWindow: reduceInformationWindow,
  contribution: reduceMapContribution,
  elements: reduceMapElements,
  filters: reduceFilters,
  cityWalk: reduceCityWalk
});

export default function resourcesMapReducer(state, action) {
  const mapKey = action.mapKey;

  // Ensure the state is initialized
  if (!state) {
    state = {};
  }

  // When no mapKey is provided, this is not a map-related action
  if (!mapKey) {
    return state;
  }

  // Apply reducers to the map's state
  let updatedState = reduceMapInitialization(state, action);
  updatedState = mapReducer(updatedState[mapKey], action);

  // Return the updated state for all the forms
  return { ...state, [mapKey]: updatedState };
}
